/* LP v2 wizard — state, step navigation, progress, gallery sync
 * (sections/afroyla-seen-wizard.liquid).
 *
 * Needs (deferred, loaded before this file): AflWizRender, AflWizLoader, AflWizCart.
 * State = { step, bp1, gift1, another ('yes'|'no'|null), bp2, gift2, checked: {1,2} }
 * where each piece is the record AflWizRender.readTile returns. Steps are
 * <div data-wiz-step> blocks inside one section; only the current one is visible.
 * The gallery + the buy-box header always show the piece the shopper last
 * touched (a design tile, a gift tile) — or the piece the current step is about.
 * Each eligibility check runs ONCE per tier (checked[t]) and takes the step's
 * place inside the box (panel.is-checking); Back → Next skips it.
 * Step 5 is a receipt with a hold countdown; Checkout adds to the cart via the
 * Cart API and goes straight to /checkout (no drawer — owner 08.09).
 * Progress weights are front-loaded on purpose (owner: "make the shopper feel
 * almost done"). */
(function () {
  'use strict';

  if (window.__aflSeenWizardInit) return;
  window.__aflSeenWizardInit = true;

  var R = window.AflWizRender;
  var L = window.AflWizLoader;
  var C = window.AflWizCart;
  if (!R || !L || !C) return;

  // progress bar % per step (step → when the step is shown)
  var PROGRESS = { 1: 12, 2: 58, 3: 72, 4: 86, 5: 96 };

  function attr(root, name, fallback) {
    var v = root.getAttribute(name);
    return v == null || v === '' ? fallback : v;
  }

  function Wizard(root) {
    var self = this;
    this.root = root;
    this.fmt = attr(root, 'data-money-format', '${{amount}}');
    var pctRaw = parseInt(attr(root, 'data-backpack-pct', '50'), 10);
    this.pct = isNaN(pctRaw) ? 50 : pctRaw; // 0 is a legal setting
    this.rows = parseInt(attr(root, 'data-rows', '2'), 10) || 2;
    this.cols = parseInt(attr(root, 'data-cols', '3'), 10) || 3;
    this.giftRows = parseInt(attr(root, 'data-gift-rows', '1'), 10) || 1;
    this.giftCols = parseInt(attr(root, 'data-gift-cols', '4'), 10) || 4;
    root.style.setProperty('--wiz-cols', String(this.cols));
    this.cfg = {
      fmt: this.fmt,
      pct: this.pct,
      freeLabel: attr(root, 'data-free-label', 'FREE'),
      priceNote: attr(root, 'data-price-note', ''),
      shipNow: attr(root, 'data-ship-now', 'Ships now'),
      shipWindow: attr(root, 'data-ship-window', 'Ships {window}'),
      giftLine: attr(root, 'data-gift-line', 'Free · worth {worth}'),
      infoBackpack: attr(root, 'data-info-backpack', 'Backpack'),
      infoGift: attr(root, 'data-info-gift', 'Your free gift'),
      sumBackpacks: attr(root, 'data-sum-backpacks', 'Backpacks ({n})'),
      sumGifts: attr(root, 'data-sum-gifts', 'Free gifts ({n})'),
      sumSubtotal: attr(root, 'data-sum-subtotal', 'Subtotal'),
      sumSave: attr(root, 'data-sum-save', 'You save'),
      sumWorth: attr(root, 'data-sum-worth', 'Free gifts worth'),
      holdMinutes: parseInt(attr(root, 'data-hold-minutes', '10'), 10) || 10,
    };
    this.panel = root.querySelector('[data-wiz-panel]');
    this.info = root.querySelector('[data-wiz-info]');
    this.state = this.blankState();

    this.designs = Array.prototype.slice.call(root.querySelectorAll('[data-wiz-designs] [data-wiz-design]'));
    this.pools = {};
    [1, 2].forEach(function (t) {
      var pool = root.querySelector('[data-wiz-gift-pool="' + t + '"]');
      self.pools[t] = {
        kind: pool ? pool.getAttribute('data-gift-kind') || 'gift' : 'gift',
        tiles: pool ? Array.prototype.slice.call(pool.querySelectorAll('[data-wiz-gift]')) : [],
      };
    });
    // price every source tile once; clones inherit the markup
    this.designs.forEach(function (el) {
      R.pricePiece(el, parseInt(el.getAttribute('data-list-cents'), 10) || 0, self.pct, self.fmt);
    });
    [1, 2].forEach(function (t) {
      self.pools[t].tiles.forEach(function (el) {
        R.priceGift(el, parseInt(el.getAttribute('data-list-cents'), 10) || 0, self.cfg);
      });
    });

    this.grids = {};
    this.buildGrid('1', this.designs, root.querySelector('[data-wiz-more="1"]'), this.rows, this.cols);
    this.buildGrid('2', this.designs, root.querySelector('[data-wiz-more="2"]'), this.rows, this.cols);
    // gifts: one row of 4 (owner 08.09), "Show more" reveals the rest
    this.buildGrid('g1', this.pools[1].tiles, root.querySelector('[data-wiz-more="g1"]'), this.giftRows, this.giftCols);
    this.buildGrid('g2', this.pools[2].tiles, root.querySelector('[data-wiz-more="g2"]'), this.giftRows, this.giftCols);

    // gift CTAs name the kind ("Claim my free leather wallet →")
    [2, 4].forEach(function (n) {
      var b = self.nextBtn(n);
      if (b) b.textContent = R.fill(b.textContent, { gift: self.pools[n === 2 ? 1 : 2].kind });
    });

    // the gallery opens on the first design so the left column is never empty
    var first = this.firstAvailable('1');
    if (first) this.showInGallery(R.readTile(first));

    // a hold left over from an earlier visit means nothing now — every receipt starts fresh
    C.resetHold();
    this.bind();
    this.setProgress(1);
    C.onExpire(function () {
      self.reset(attr(self.root, 'data-hold-expired', ''));
    });
  }

  Wizard.prototype.blankState = function () {
    return { step: 1, bp1: null, gift1: null, another: null, bp2: null, gift2: null, checked: {} };
  };

  Wizard.prototype.buildGrid = function (key, tiles, moreBtn, rows, cols) {
    var grid = this.root.querySelector('[data-wiz-grid="' + key + '"]');
    if (!grid) return;
    grid.style.setProperty('--wiz-cols', String(cols));
    this.grids[key] = R.fillGrid(grid, tiles, rows, cols, moreBtn);
    // HC Pixel click name per grid (the source tiles are one hidden pool cloned into two grids),
    // suffixed with the wizard step the grid sits on: 1 first backpack, 2 gift 1, 3 second backpack, 4 gift 2
    var hcKey = { 1: 'x-wiz-design-1', g1: 'x-wiz-gift-2', 2: 'x-wiz-design-3', g2: 'x-wiz-gift-4' }[key];
    if (hcKey) {
      this.grids[key].forEach(function (c) {
        c.setAttribute('data-hc-el', hcKey);
      });
    }
  };

  /* "Your picks so far": one tile per piece already chosen, in order; a tap goes
     back to the step that piece belongs to. Hidden until something is chosen
     and on the receipt step (which lists everything anyway). */
  Wizard.prototype.paintPicks = function () {
    var wrap = this.root.querySelector('[data-wiz-picks]');
    var row = this.root.querySelector('[data-wiz-picks-row]');
    if (!wrap || !row) return;
    var s = this.state;
    var items = [];
    if (s.bp1) items.push({ piece: s.bp1, step: 1, kind: 'backpack' });
    if (s.gift1) items.push({ piece: s.gift1, step: 2, kind: 'gift' });
    if (s.another === 'yes' && s.bp2) items.push({ piece: s.bp2, step: 3, kind: 'backpack' });
    if (s.another === 'yes' && s.gift2) items.push({ piece: s.gift2, step: 4, kind: 'gift' });
    // the current step's own pick is still being made — show what came BEFORE it
    items = items.filter(function (it) {
      return it.step < s.step;
    });
    wrap.hidden = !items.length || s.step === 5;
    var self = this;
    row.innerHTML = items
      .map(function (it) {
        var p = it.piece;
        var price = it.kind === 'gift' ? '<b class="afl-wiz__free">' + R.esc(self.cfg.freeLabel) + '</b>' : '<b>' + R.esc(R.money(R.payCents(p.listCents, self.cfg.pct), self.fmt)) + '</b>';
        return (
          '<button type="button" class="afl-wiz__pick" data-wiz-back="' + it.step + '" data-hc-el="x-wiz-pick" aria-label="' + R.esc(p.name) + '">' +
          '<img class="afl-wiz__pick-img" src="' + R.esc(p.src) + '" alt="" width="44" height="58" loading="lazy">' +
          '<span class="afl-wiz__pick-name">' + R.esc(p.name) + '</span>' +
          '<span class="afl-wiz__pick-price">' + price + '</span></button>'
        );
      })
      .join('');
  };

  Wizard.prototype.firstAvailable = function (key) {
    var clones = this.grids[key] || [];
    for (var i = 0; i < clones.length; i += 1) if (!clones[i].disabled) return clones[i];
    return null;
  };

  Wizard.prototype.select = function (key, tile) {
    (this.grids[key] || []).forEach(function (t) {
      t.setAttribute('aria-pressed', t === tile ? 'true' : 'false');
    });
    return R.readTile(tile);
  };

  Wizard.prototype.showInGallery = function (piece) {
    R.paintGallery(this.root, piece, this.cfg);
  };

  Wizard.prototype.nextBtn = function (step) {
    return this.root.querySelector('[data-wiz-next="' + step + '"]');
  };

  /* write a button's label (+ optional second line) whether it is one- or two-line */
  function setBtn(btn, label, sub) {
    if (!btn) return;
    var l = btn.querySelector('.afl-wiz__btn-l');
    var t = btn.querySelector('.afl-wiz__btn-t');
    if (!l) {
      btn.textContent = label;
      return;
    }
    l.textContent = label;
    if (t) {
      t.textContent = sub || '';
      t.hidden = !sub;
    }
  }

  Wizard.prototype.setProgress = function (step) {
    var bar = this.root.querySelector('[data-wiz-bar]');
    if (bar) bar.style.width = (PROGRESS[step] || 0) + '%';
    this.root.querySelectorAll('[data-wiz-label]').forEach(function (li) {
      var n = parseInt(li.getAttribute('data-wiz-label'), 10);
      li.classList.toggle('is-done', n < step);
      li.classList.toggle('is-current', n === step);
    });
  };

  /* the piece each step is "about", for the gallery when the step opens */
  Wizard.prototype.pieceForStep = function (step) {
    var s = this.state;
    if (step === 2) return s.gift1 || s.bp1;
    if (step === 3) return s.bp2 || s.bp1;
    if (step === 4) return s.gift2 || s.bp2;
    return s.bp1;
  };

  /* Scroll the box into view: on one-column layouts land on the name/price
     header (the full-width photo is one flick up, the step right below), on two
     columns on the element itself. The desktop layout scrolls a wrapper, not
     the window, so window.scrollTo would do nothing. */
  Wizard.prototype.scrollTo = function (el) {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var target = window.innerWidth < 990 && this.info ? this.info : el;
    if (target && target.scrollIntoView) target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  };

  Wizard.prototype.show = function (step, noScroll) {
    this.state.step = step;
    if (this.panel) this.panel.classList.remove('is-checking');
    this.root.querySelectorAll('[data-wiz-step]').forEach(function (el) {
      var on = el.getAttribute('data-wiz-step') === String(step);
      el.hidden = !on;
      el.classList.toggle('is-current', on);
    });
    this.setProgress(step);
    this.paintPicks();
    var piece = this.pieceForStep(step);
    if (piece) this.showInGallery(piece);
    if (step === 5) C.startHold(this.root, this.cfg.holdMinutes);
    if (!noScroll) {
      // land on the picks strip when it shows (it sits between the sticky progress and the step)
      var picks = this.root.querySelector('[data-wiz-picks]');
      this.scrollTo(picks && !picks.hidden ? picks : this.root.querySelector('[data-wiz-step="' + step + '"]'));
    }
  };

  /* reveal header for gift tier t: {gift} = kind, {worth} = the chosen gift's list price */
  Wizard.prototype.paintReveal = function (t, piece) {
    var head = this.root.querySelector('[data-wiz-reveal="' + t + '"]');
    if (!head) return;
    var worth = piece ? piece.listCents : 0;
    var tokens = { gift: this.pools[t].kind, worth: R.money(worth, this.fmt) };
    var put = function (sel, text) {
      var el = head.querySelector(sel);
      if (el) el.textContent = text;
    };
    put('[data-wiz-reveal-head]', R.fill(attr(this.root, 'data-reveal-' + t + '-head', ''), tokens));
    put('[data-wiz-reveal-sub]', R.fill(attr(this.root, 'data-reveal-' + t + '-sub', ''), tokens));
  };

  Wizard.prototype.loaderCfg = function (t) {
    var r = this.root;
    var p = 'data-loader-' + t + '-';
    return {
      title: attr(r, p + 'title', ''),
      lines: [attr(r, p + 'a', ''), attr(r, p + 'b', ''), attr(r, p + 'c', ''), attr(r, p + 'd', '')],
      done: attr(r, p + 'done', 'Approved'),
      fine: attr(r, 'data-loader-fine', ''),
      ms: parseInt(attr(r, p + 'ms', t === 2 ? '1600' : '1300'), 10) || 1300,
    };
  };

  /* gift default = the highest-value available tile in the pool, so the reveal
     headline quotes the best "worth $" (the shopper may change it) */
  Wizard.prototype.defaultGift = function (key) {
    var clones = this.grids[key] || [];
    var best = null;
    var bestCents = -1;
    for (var i = 0; i < clones.length; i += 1) {
      if (clones[i].disabled) continue;
      var cents = parseInt(clones[i].getAttribute('data-list-cents'), 10) || 0;
      if (cents > bestCents) {
        bestCents = cents;
        best = clones[i];
      }
    }
    return best;
  };

  Wizard.prototype.pieces = function () {
    var s = this.state;
    var out = [];
    if (s.bp1) out.push(Object.assign({ kind: 'backpack' }, s.bp1));
    if (s.gift1) out.push(Object.assign({ kind: 'gift' }, s.gift1));
    if (s.another === 'yes' && s.bp2) out.push(Object.assign({ kind: 'backpack' }, s.bp2));
    if (s.another === 'yes' && s.gift2) out.push(Object.assign({ kind: 'gift' }, s.gift2));
    return out;
  };

  Wizard.prototype.paintSummary = function () {
    var self = this;
    var pieces = this.pieces();
    var list = this.root.querySelector('[data-wiz-summary]');
    if (list) {
      list.innerHTML = pieces
        .map(function (p) {
          return R.lineHtml(p, self.cfg);
        })
        .join('');
    }
    var totals = this.root.querySelector('[data-wiz-totals]');
    if (totals) totals.innerHTML = R.totalsHtml(pieces, this.cfg);
    // the hold strip only makes sense when there is a gift to hold
    var hold = this.root.querySelector('[data-wiz-hold]');
    if (hold) {
      hold.hidden = !pieces.some(function (p) {
        return p.kind === 'gift';
      });
    }
  };

  /* Open gift tier t: run its check once (in place of the step), land on the
     reveal step with a gift preselected. */
  Wizard.prototype.goGift = function (t, fromStep, toStep) {
    var self = this;
    var key = 'g' + t;
    var btn = this.nextBtn(fromStep);
    // an empty / sold-out gift pool: no theatre, no dead end — skip the gift step
    if (!this.defaultGift(key)) {
      this.state['gift' + t] = null;
      if (t === 1) this.show(3);
      else {
        this.paintSummary();
        this.show(5);
      }
      return Promise.resolve();
    }
    var land = function () {
      if (btn) btn.removeAttribute('aria-busy');
      // keep a pick the shopper already made (Back → Next); default only the first time
      var kept = self.state['gift' + t] && self.state['gift' + t].el;
      var pick = kept && kept.getAttribute('aria-pressed') === 'true' ? kept : self.defaultGift(key);
      var piece = pick ? self.select(key, pick) : null;
      self.state['gift' + t] = piece;
      self.paintReveal(t, piece);
      var next = self.nextBtn(toStep);
      if (next) next.disabled = !piece;
      self.show(toStep);
    };
    if (this.state.checked[t]) {
      land();
      return Promise.resolve();
    }
    if (btn) btn.setAttribute('aria-busy', 'true');
    // the check takes the step's place: steps hide, the loader card shows
    this.root.querySelectorAll('[data-wiz-step]').forEach(function (el) {
      el.hidden = true;
    });
    if (this.panel) this.panel.classList.add('is-checking');
    var run = L.run(this.root, this.loaderCfg(t)); // shows the card synchronously
    this.scrollTo(this.root.querySelector('[data-wiz-loader]')); // its scroll-margin clears the sticky progress strip
    return run.then(function () {
      self.state.checked[t] = true;
      land();
      setTimeout(function () {
        L.burst(self.root.querySelector('[data-wiz-reveal="' + t + '"] .afl-wiz__h3'));
      }, 380);
    });
  };

  /* Checkout: add everything via the Cart API (pre-order properties ride along),
     then hand the shopper to Shopify's checkout. */
  Wizard.prototype.checkout = function () {
    var self = this;
    var btn = this.nextBtn(5);
    var pieces = this.pieces();
    if (!pieces.length || (btn && btn.getAttribute('aria-busy') === 'true')) return;
    if (btn) {
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('data-label', btn.textContent);
      btn.textContent = attr(this.root, 'data-cta-5-busy', btn.textContent);
    }
    C.releaseForCheckout();
    var restore = function () {
      if (!btn) return;
      btn.removeAttribute('aria-busy');
      btn.textContent = btn.getAttribute('data-label') || btn.textContent;
    };
    C.addToCart(this.root, pieces, {})
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        restore();
        // 422 = a piece sold out since the page rendered: say so and go back to the picker
        // (a permalink could not carry the pre-order properties and would 404 on the variant)
        if (err && err.status === 422) {
          self.reset(attr(self.root, 'data-sold-out', 'One of your pieces just sold out. Pick again.'));
          return;
        }
        // any other refusal (throttle, network): fall back to the permalink so nothing is lost
        var ids = {};
        pieces.forEach(function (p) {
          ids[p.variantId] = (ids[p.variantId] || 0) + 1;
        });
        var lp = self.root.getAttribute('data-lp-key') || '';
        window.location.href = '/cart/' + Object.keys(ids).map(function (id) {
          return id + ':' + ids[id];
        }).join(',') + (lp ? '?attributes[_afl_lp]=' + encodeURIComponent(lp) : '');
      });
  };

  /* Back to step 1 with everything cleared; `notice` (hold ended / sold out)
     is printed at the top of the step so the shopper knows why. */
  Wizard.prototype.reset = function (notice) {
    this.state = this.blankState();
    var self = this;
    C.resetHold();
    Object.keys(this.grids).forEach(function (k) {
      self.grids[k].forEach(function (t) {
        t.setAttribute('aria-pressed', 'false');
      });
    });
    this.root.querySelectorAll('[data-wiz-another]').forEach(function (b) {
      b.setAttribute('aria-checked', 'false');
    });
    var second = this.root.querySelector('[data-wiz-second]');
    if (second) second.hidden = true;
    [1, 2, 3, 4].forEach(function (n) {
      var b = self.nextBtn(n);
      if (b) b.disabled = true;
    });
    var note = this.root.querySelector('[data-wiz-notice]');
    if (note) {
      note.textContent = notice || '';
      note.hidden = !notice;
    }
    this.show(1);
  };

  Wizard.prototype.bind = function () {
    var self = this;
    var root = this.root;

    root.addEventListener('click', function (event) {
      var t = event.target.closest ? event.target : null;
      if (!t) return;

      var tile = t.closest('[data-wiz-grid] .afl-wiz__tile');
      if (tile && root.contains(tile) && !tile.disabled) {
        var key = tile.closest('[data-wiz-grid]').getAttribute('data-wiz-grid');
        var piece = self.select(key, tile);
        self.showInGallery(piece);
        if (key === '1') {
          self.state.bp1 = piece;
          self.nextBtn(1).disabled = false;
        } else if (key === '2') {
          self.state.bp2 = piece;
          self.nextBtn(3).disabled = false;
        } else if (key === 'g1') {
          self.state.gift1 = piece;
          self.paintReveal(1, piece);
          self.nextBtn(2).disabled = false;
        } else if (key === 'g2') {
          self.state.gift2 = piece;
          self.paintReveal(2, piece);
          self.nextBtn(4).disabled = false;
        }
        return;
      }

      var another = t.closest('[data-wiz-another]');
      if (another) {
        var val = another.getAttribute('data-wiz-another');
        self.state.another = val;
        root.querySelectorAll('[data-wiz-another]').forEach(function (b) {
          b.setAttribute('aria-checked', b === another ? 'true' : 'false');
        });
        var second = root.querySelector('[data-wiz-second]');
        var btn3 = self.nextBtn(3);
        if (val === 'yes') {
          second.hidden = false;
          setBtn(btn3, attr(root, 'data-cta-3-yes', 'Add this backpack →'), attr(root, 'data-cta-3-yes-sub', ''));
          btn3.disabled = !self.state.bp2;
        } else {
          second.hidden = true;
          setBtn(btn3, attr(root, 'data-cta-3-no', 'Review my order →'), '');
          btn3.disabled = false;
        }
        return;
      }

      var next = t.closest('[data-wiz-next]');
      if (next && !next.disabled && next.getAttribute('aria-busy') !== 'true') {
        var step = parseInt(next.getAttribute('data-wiz-next'), 10);
        if (step === 1 && self.state.bp1) self.goGift(1, 1, 2);
        else if (step === 2 && self.state.gift1) self.show(3);
        else if (step === 3) {
          if (self.state.another === 'yes' && self.state.bp2) self.goGift(2, 3, 4);
          else if (self.state.another === 'no') {
            self.paintSummary();
            self.show(5);
          }
        } else if (step === 4 && self.state.gift2) {
          self.paintSummary();
          self.show(5);
        } else if (step === 5) self.checkout();
        return;
      }

      var back = t.closest('[data-wiz-back]');
      if (back) {
        self.show(parseInt(back.getAttribute('data-wiz-back'), 10));
      }
    });
  };

  function boot() {
    document.querySelectorAll('[data-afl-wizard]').forEach(function (root) {
      if (root.__aflWizard) return;
      root.__aflWizard = new Wizard(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
